<template>
  <v-dialog
    :value="value"
    @input="input"
    width="800"
  >
    <JournalEntryForm
      v-model="journalEntry"
      title="Journaleintrag hinzufügen"
      @submit="save"
      @cancel="hide"
    />
  </v-dialog>
</template>

<script>
import JournalEntry from '@/models/journal-entry';

export default {
  name: 'AddJournalEntryDialog',
  data() {
    return {
      journalEntry: new JournalEntry({
        business_id: this.business.id,
      }),
    };
  },
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    business: {
      type: Object,
      required: true,
    },
  },
  methods: {
    input(val) {
      this.$emit('input', val);
    },
    async save() {
      await this.journalEntry.save();
      this.$showSnackbar({ text: 'Erfolgreich gespeichert.', color: 'success' });
      this.hide();
      this.journalEntry = new JournalEntry({
        business_id: this.business.id,
      });
    },
    hide() {
      this.$emit('input', false);
    },
  },
};
</script>
